import { jwtDecode } from "jwt-decode";
import { RootState, store } from "state/store";

export const decodeToken = (): any => {
  const token = (store.getState() as RootState).auth.token;
  if (token !== "" && token !== null && token !== undefined) {
    return jwtDecode(token);
  }
};
